const module = {
  config: {
    name: "pengaturan",
    svg: "../static/img/icon/menu/tools-line.svg",
    desc: "Berisi modul pengaturan data untuk kebutuhan data dan landing page",
    layout: true
  },
  routes: [
    // Konten Landing Page
    {
      name: "Konten Landing Page",
      icon: "ri-table-fill",
      path: "/landing-page",
      component: () => import("./landing-page.vue"),
      separator: "Landing Page"
    },
    // Featured Books
    {
      name: "Featured Books",
      icon: "ri-book-marked-fill",
      path: "/featured-book",
      component: () => import("./featured-book.vue"),
      separator: "Landing Page"
    },
    // Tata Tertib
    {
      name: "Tata Tertib",
      icon: "ri-spam-2-fill",
      path: "/tata-tertib",
      component: () => import("./fine.vue"),
      separator: "Pengaturan"
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/settings/_index.js